import { ThemeProps, ThemedColor, DefaultTheme } from 'styled-components';

enum THEMED_COLOR_TYPES {
  FAMILY = 'FAMILY',
  WHITE = 'WHITE',
  GRAY = 'GRAY',
  TEXT_BLUE = 'FONT_BLUE',
  TEXT_GREY = 'TEXT_GREY',
  DARK_GREY = 'DARK_GREY',
  TEXT_DISABLED = 'TEXT_DISABLED',
  LINK = 'LINK',
  DROPDOWN_SHADOW = 'DROPDOWN_SHADOW',
  HEADER_BG = 'HEADER_BG',
  FORM_BG = 'FORM_BG',
  INPUT_BORDER = 'INPUT_BORDER',
  INPUT_BG = 'FORMINPUT_BG_BG',
  INPUT_FOCUS_BG = 'INPUT_FOCUS_BG',
  INPUT_FOCUS_BORDER = 'INPUT_FOCUS_BORDER',
  INPUT_ENTERED_BG = 'INPUT_ENTERED_BG',
  INPUT_ENTERED_BORDER = 'INPUT_ENTERED_BORDER',
  ERROR = 'ERROR',
  BUTTON_BG = 'BUTTON_BG',
  BUTTON_TEXT = 'BUTTON_TEXT',
  BUTTON_BORDER = 'BUTTON_BORDER',
  BUTTON_DARK_BG = 'BUTTON_DARK_BG',
  BUTTON_DARK_TEXT = 'BUTTON_DARK_TEXT',
  BUTTON_DARK_BORDER = 'BUTTON_DARK_BORDER',
  FAQ_TITLE = 'FAQ_TITLE',
  ARROW = 'ARROW'
}

const themedColor = (color: ThemedColor) => (
  props: ThemeProps<DefaultTheme>
): string => props.theme.colors[color];

export { THEMED_COLOR_TYPES };
export type ThemedColorReturn = ReturnType<typeof themedColor>;
export default themedColor;
